import appApi from "@/services/api";
import { exceptionRequestMsg } from "@/assets/js/util";

const state = {
  loadingPage: true,
  arrendamiento: [],
  interesesAzul: [],
  interesesPlatino: [],
};

const getters = {
  getArrendamiento: (state) => {
    return state.arrendamiento;
  },
};

const mutations = {
  setInteresesByArrendamiento: (state, intereses) => {
    state.arrendamiento = intereses.arrendamiento;
    state.interesesAzul = intereses.interes_azul;
    state.interesesPlatino = intereses.interes_platino;
    state.loadingPage = false;
  },

  resetState: (state) => {
    state.arrendamiento, state.interesesAzul, state.interesesPlatino = [];
    state.loadingPage = true;
  },
};

const actions = {
  fetchInteresesByArrendamiento: async ({ commit }, arrendamiento_id) => {
    commit("resetState");
    try {
      const response = await appApi().get(
        `arrendamientos/detalle/${arrendamiento_id}`
      );

      commit("setInteresesByArrendamiento", response.data);
    } catch (e) {
      exceptionRequestMsg(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
